module.exports = __webpack_public_path__ + "img/line-levang-p.d6c2b9cb.jpg";